import { selectBonusesErrorCode } from 'modules/bonuses/store/bonuses.selectors'
import { useSelector } from 'react-redux'

export const ERROR_BUNDLES_CALL_MESSAGE =
  'Ha habido un problema en la carga de bonos, puede que los precios no sean correctos.'

export const hasBundlesCallError = () => !!useSelector(selectBonusesErrorCode)
